module.exports = __webpack_public_path__ + "static/media/project5.b4d03b9a.jpg";